import React from 'react';
import { cn } from '../../lib/cn';

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'w-full rounded-[var(--r-sm)] border border-[var(--cream-2)] bg-[var(--cream-1)] px-3 py-2 text-sm text-[var(--ink-1)] outline-none focus:border-[var(--ai-4)]',
        className,
      )}
      {...props}
    />
  );
});
